import React from 'react';
import { useAccordionEvents, useTabs } from './hooks';
import './style.scss';
import { AccordionTabProps } from './AccordionTab';

export interface AccordionProps {
  /**
   * Children should be `AccordionTab` elements
   */
  children: React.ReactNode;
}

const Accordion: React.FC<AccordionProps> = ({ children }) => {
  const accordion = React.useRef<HTMLDivElement>(null);
  const tabs = useTabs(children as React.ReactElement<AccordionTabProps>);
  const { handleHashChange } = useAccordionEvents(accordion.current);

  React.useEffect(() => {
    window.addEventListener('hashchange', handleHashChange);
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, [window, accordion.current]);

  React.useEffect(() => {
    handleHashChange();
  }, [tabs.length]);

  return (
    <div className="m-accordion" ref={accordion}>
      {React.Children.map(tabs, (tab) => {
        return React.cloneElement(tab, {
          ...tab.props,
          parent: accordion?.current,
        });
      })}
    </div>
  );
};

export default Accordion;
